//Page Texture
import {storyList} from "./story_data";

window.addEventListener('load', () => {
    setTimeout(() => {
        document.querySelector(':root').style.setProperty('--overlay-texture-mode', 'overlay')
        document.querySelector(':root').style.setProperty('--overlay-texture-opacity', '0.5')
    }, 1)
})

// ViewportHeight
const updateViewportHeight = () => {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
};
updateViewportHeight();

['/cover', '/story', '/ending', '/ar'].forEach((page) => {
    if(window.location.href.indexOf(page) > -1){
        window.addEventListener('resize', ()=>{
            updateViewportHeight()
        });
        window.addEventListener('orientationchange', () => {
            updateViewportHeight()
        });
    }
})

// Check in App
window.checkInApp = function () {
    document.body.classList.add('in-app')
    let memberId = new URLSearchParams(window.location.search).get('memberId')
    let isWebview = navigator.userAgent.indexOf('DcardWebView') > -1
    if(memberId || isWebview){
        document.body.classList.add('in-app')
        return true
    }else{
        document.body.classList.remove('in-app')
        return false
    }
}

window.getStorySelected = function () {
    let result = null
    storyList.forEach(text => {
        if(window.location.href.indexOf(text) > -1){
            result = storyList.indexOf(text)
        }
    });

    return result
}

// Preload Img
window.preloadImages = function (url) {
    let preloadImg = new Image()
    preloadImg.src = url
}

// Click Once
window.clickDebounce = function () {
    let el = document.querySelectorAll('.click-once')
    el.forEach(element => {
        element.addEventListener('click', function (e) {
            e.currentTarget.style.touchAction = 'none'
            e.currentTarget.style.pointerEvents = 'none'
        })
    })
}